import { render, staticRenderFns } from "./ModalAddMaterial.vue?vue&type=template&id=17fa1673"
import script from "./ModalAddMaterial.vue?vue&type=script&lang=ts"
export * from "./ModalAddMaterial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports